// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__mSA2L","navItem":"Navbar_navItem__1jisU"};